import { Apps, FormatListBulleted, Menu, Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Select,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { serviceApi } from "../Component/API/Api";
import ServiceCardItem from "../Component/Homepage Components/Trending Services/ServiceCardItem";
import ServiceCardItemFlat from "../Component/Homepage Components/Trending Services/ServiceCardItemFlat";
import CategoryList from "../Component/ServiceList Components/CategoryList";

import loading from "../images/loader.gif";
import ResCategoryList from "../Component/ServiceList Components/ResCategoryList";
import { useParams } from "react-router-dom";
import Seo from "../store/Seo";

const ServiceList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [firstLoadIndicator, setFirstLoadIndicator] = useState(true);
  const [resLeftToggle, setResLeftToggle] = useState(false);
  const [searchFieldText, setSearchFieldText] = useState("");
  const [viewMode, setViewMode] = useState("grid");
  const [serviceListData, setServiceListData] = useState([]);
  const [page, setPage] = useState(1);
  const [sourceValueId, setSourceValueId] = useState("");
  const [source, setSource] = useState("category");


  const handlePageChange = (event, value) => {
    setFirstLoadIndicator(false);
    setPage(value);
  };

  useEffect(() => {
    // Fetch services on first load or when page changes
    setFirstLoadIndicator(true);
    fetch(serviceApi)
      .then((res) => res.json())
      .then((result) => {
        setServiceListData(result);
        setFirstLoadIndicator(false);
      })
      .catch((error) => {
        console.error("Service API Error:", error);
        setFirstLoadIndicator(false);
      });
  }, []);

  const handleSearch = () => {
    setFirstLoadIndicator(true);
    fetch(
      `https://aps.songjukti.com/profile/login/api_service/new_24/all_service_search.php?s_query=${searchFieldText}`
    )
      .then((res) => res.json())
      .then((result) => {
        setServiceListData(result);
        setFirstLoadIndicator(false);
      })
      .catch((error) => {
        console.error("Search API Error:", error);
        setFirstLoadIndicator(false);
      });
  };

  return (
    <Box>
       <Seo
        title="Find Professional Freelance Services in Bangladesh"
        description="Browse top-rated freelancers and agencies in design, development, writing, photography, and marketing — all in one place on Songjukti."
        keywords="freelancer services Bangladesh, hire designers, hire developers, Songjukti freelancers, creative agencies"
        url="https://www.songjukti.com/serviceslist"
      />
      <Container sx={{ mt: 6 }}>
        <Grid container spacing={2}>
          {/* Sidebar (Desktop) */}
          <Grid item md={3} xs={12} sx={{ display: { xs: "none", md: "grid" } }}>
            <Paper elevation={3} sx={{ padding: 2, minHeight: "90vh", }}>
              <CategoryList
  setServiceListData={setServiceListData}
  page={page}
  setFirstLoadIndicator={setFirstLoadIndicator} // ✅ Fixed name
  setSourceValueId={setSourceValueId}
  sourceValueId={sourceValueId}
  setSource={setSource}
  source={source}
/>

              <Divider light sx={{ my: 2 }} />
            </Paper>
          </Grid>

          {/* Sidebar (Mobile) */}
          {isMobile && resLeftToggle && (
            <Paper
              elevation={3}
              sx={{
                position: "absolute",
                top: "60px",
                left: 0,
                width: "90%",
                minHeight: "90vh",
                padding: 2,
                zIndex: 5,
              }}
            >
              <ResCategoryList
  setServiceListData={setServiceListData}
  page={page}
  setFirstLoadIndicator={setFirstLoadIndicator} // ✅ Fixed name
  setResLeftToggle={setResLeftToggle}
  setSourceValueId={setSourceValueId}
  sourceValueId={sourceValueId}
  setSource={setSource}
  source={source}
/>

              <Divider light sx={{ my: 2 }} />
            </Paper>
          )}

          {/* Main Content */}
          <Grid item xs={12} md={9}>
            <Stack sx={{ p: 2 }}>
              {/* Search + View Mode Toggle */}
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ width: { xs: "100%", md: "50%" } }}
                  alignItems="center"
                >
                  {isMobile && (
                    <IconButton size="small" onClick={() => setResLeftToggle(!resLeftToggle)}>
                      <Menu />
                    </IconButton>
                  )}
                  <OutlinedInput
                    fullWidth
                    color="success"
                    size="small"
                    placeholder="Search..."
                    value={searchFieldText}
                    onChange={(e) => setSearchFieldText(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={handleSearch}>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Stack>
                <Stack direction="row" spacing={1} sx={{ display: { xs: "none", md: "flex" } }}>
                  <Button
                    variant={viewMode === "grid" ? "outlined" : "text"}
                    onClick={() => setViewMode("grid")}
                    size="small"
                  >
                    <Apps />
                  </Button>
                  <Button
                    variant={viewMode === "list" ? "outlined" : "text"}
                    onClick={() => setViewMode("list")}
                    size="small"
                  >
                    <FormatListBulleted />
                  </Button>
                </Stack>
              </Stack>

              {/* Content Grid */}
              <Box sx={{ flexGrow: 1 }} mt={2}>
                {firstLoadIndicator ? (
                  <Box
                    sx={{
                      height: "70vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={loading}
                      alt="Loading..."
                      style={{ width: "100px", height: "100px" }}
                    />
                  </Box>
                ) : serviceListData?.length > 0 ? (
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                  >
                    {serviceListData.map((data) =>
                      viewMode === "list" ? (
                        <Grid item xs={12} key={data.service_refer}>
                          <ServiceCardItemFlat data={data} />
                        </Grid>
                      ) : (
                        <Grid item xs={2} sm={4} md={4} key={data.service_refer}>
                          <ServiceCardItem data={data} />
                        </Grid>
                      )
                    )}
                  </Grid>
                ) : (
                  <Box
                    sx={{
                      height: "70vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography sx={{ fontSize: "25pt", fontWeight: 600 }}>
                      No data found!
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Pagination */}
              <Divider light sx={{ mt: 4, mb: 2 }} />
              <Pagination
                count={10}
                page={page}
                onChange={handlePageChange}
                variant="outlined"
                color="primary"
                sx={{ alignSelf: "center" }}
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ServiceList;
